/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts https://shopify.dev/api/admin/rest/reference/online-store/theme
 * API Version: 2022-01
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyAssetKey,
  ShopifyAssetToThemeKey,
  ShopifyShopKey,
  ShopifyThemeKey,
  ShopifyThemeToAssetsKey,
  ShopifyThemeToShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyThemeKey,
  "2022-01": {
    name: "Shopify Theme",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "id" } },
      },
      {
        name: "Assets",
        fieldType: FieldType.HasMany,
        key: ShopifyThemeToAssetsKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyAssetKey,
          inverseFieldKey: ShopifyAssetToThemeKey,
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "name" } },
      },
      {
        name: "Previewable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "previewable" } },
      },
      {
        name: "Processing",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "processing" } },
      },
      {
        name: "Role",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "role" } },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "created_at" } },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "updated_at" } },
      },
      {
        name: "Theme Store ID",
        fieldType: FieldType.Number, // external id, there's no related model in the Shopify API
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "theme_store_id" } },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyThemeToShopKey,
        contributorConfiguration: { [ShopifyDominion.id]: { shopifyFieldKey: "shop_id" } },
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    syncConfig: { type: "rest_list", resource: "theme" },
  },
  "2025-04": {
    graphQLTypename: "OnlineStoreTheme",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: { shopifyFieldKey: "id", graphQLFieldKey: "id", availableInWebhook: ["themes/create", "themes/update"] },
        },
      },
      {
        name: "Assets",
        fieldType: FieldType.HasMany,
        key: ShopifyThemeToAssetsKey,
        configuration: {
          dependent: "delete",
          relatedModelKey: ShopifyAssetKey,
          inverseFieldKey: ShopifyAssetToThemeKey,
        },
      },
      {
        name: "Name",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "name",
            graphQLFieldKey: "name",
            availableInWebhook: ["themes/create", "themes/update"],
          },
        },
      },
      {
        name: "Previewable",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "previewable",
            deprecated: true,
            availableInWebhook: ["themes/create", "themes/update"],
          },
        },
      },
      {
        name: "Processing",
        fieldType: FieldType.Boolean,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "processing",
            graphQLFieldKey: "processing",
            availableInWebhook: ["themes/create", "themes/update"],
          },
        },
      },
      {
        name: "Role",
        fieldType: FieldType.Enum,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "role",
            graphQLFieldKey: "role",
            isShopifyEnum: true,
            availableInWebhook: ["themes/create", "themes/update"],
          },
        },
        configuration: {
          allowOther: true,
          allowMultiple: false,
          options: [
            { name: "ARCHIVED" },
            { name: "DEMO" },
            { name: "DEVELOPMENT" },
            { name: "LOCKED" },
            { name: "MAIN" },
            { name: "UNPUBLISHED" },
            { name: "MOBILE" },
          ],
        },
      },
      {
        name: "Shopify Created At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "created_at",
            graphQLFieldKey: "createdAt",
            availableInWebhook: ["themes/create", "themes/update"],
          },
        },
      },
      {
        name: "Shopify Updated At",
        fieldType: FieldType.DateTime,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "updated_at",
            graphQLFieldKey: "updatedAt",
            availableInWebhook: ["themes/create", "themes/update"],
          },
        },
      },
      {
        name: "Theme Store ID",
        fieldType: FieldType.Number,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            shopifyFieldKey: "theme_store_id",
            graphQLFieldKey: "themeStoreId",
            availableInWebhook: ["themes/create", "themes/update"],
          },
        },
      },
      {
        name: "Prefix",
        fieldType: FieldType.String,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "prefix", graphQLOnlyField: true } },
      },
      {
        name: "Processing Failed",
        fieldType: FieldType.Boolean,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "processingFailed", graphQLOnlyField: true } },
      },
    ],
    syncConfig: {
      type: "graphql_list",
      resource: "themes",
      filters: {},
    },
  },
};

export const ShopifyTheme = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
